import { render, staticRenderFns } from "./blockLeftBottom2.vue?vue&type=template&id=99c86228&scoped=true&"
import script from "./blockLeftBottom2.vue?vue&type=script&lang=js&"
export * from "./blockLeftBottom2.vue?vue&type=script&lang=js&"
import style0 from "./blockLeftBottom2.vue?vue&type=style&index=0&id=99c86228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c86228",
  null
  
)

export default component.exports